<template>
  <div class="safari">
    <v-container grid-list-xs>
        <h1>Safari</h1>
        <p>Safari is a swahili word meaning journey, travelling, touring. We can organize the safari tour of your choice, allowing you to discover the unspoiled natural beauties of Tanzania.</p>
        <p>Our safari tours include:
            <ul>
                <li>Accomodation (lodge or comfortable tented camp)</li>
                <li>Meals (breakfast, lunch, dinner)</li>
                <li>Transport to/from the closest airport to the selected National Park</li>
                <li>Entrance</li>
                <li>All transports between destinations and to/from included activities</li>

            </ul></p>
        <v-layout row wrap>
            <v-flex  v-for="(safari, index) in safaris" :key="safari.id" xs12 md6 xl3 pa-2>
                <v-card class="mx-auto" @click="$router.push({name: 'Details', params:{ id:safari.id, safariProp:safaris[index] }})" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)">
                    <v-img
                    height="200px"
                    :src="require(`../../public/img/img/destination_${safari.image}.jpg`)"
                    aspect-ratio="2.75"
                    ></v-img>
                    <v-card-title v-text="safari.title"></v-card-title>
                    <!-- <v-card-subtitle v-text="safari.duration"></v-card-subtitle> -->
                    <v-card-actions>
                        <v-btn
                          text
                          color="deep-purple accent-4"
                        >
                          Read
                        </v-btn>
                        <!-- <v-spacer></v-spacer>
                        <v-btn icon>
                          <v-icon>mdi-heart</v-icon>
                        </v-btn>
                        <v-btn icon>
                          <v-icon>mdi-share-variant</v-icon>
                        </v-btn> -->
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
  </div>
</template>

<script>
import firebase from '../configFirebase.js'
export default {
	name: 'Safari',
    data(){
        return{
            safaris:[]
        }
    },
    mounted(){
    firebase.db.collection('travels').onSnapshot((snapShot) => {
            this.safaris=[];
            snapShot.forEach((safari)  => {
                if(safari.data().kind==="safari")
                    this.safaris.push({
                        id:safari.id,
                        title:safari.data().title,
                        duration:safari.data().duration,
                        image:safari.data().image,
                        kind:safari.data().kind,
                        description:safari.data().description
                })
            });
        });
    }
}
</script>